<template>
  <div>
    <div class="buy" :class="{ hidePrice: hidePrice }">
      <span class="desc">
        <span class="text">
          开通{{ activeTab === 20 ? '星耀直通卡' : '研力特权卡' }}，仅售<span class="num">{{
            priceInfo.price
          }}</span>
        </span>
        <span v-if="time" class="time">活动倒计时：<common-timer :endTime="time" /> </span>
      </span>
      <span class="del" v-if="!isUpdate && priceInfo.originalPrice"
        >原价{{ priceInfo.originalPrice }}</span
      >
      <span class="btn" v-if="!isUpdate && isShowBuy" @click="generateOrder(activeTab)"
        ><span class="btn-open">马上开通</span></span
      >
      <span class="btn" v-if="!isUpdate && !isShowBuy" @click="openChat"
        ><span class="btn-open">联系客服</span></span
      >
      <span class="btn" v-if="isUpdate" @click="openChat">
        <span class="btn-chat">联系客服</span>
        <span class="btn-desc">计算升级差价</span>
      </span>
    </div>
    <div v-if="hidePrice" class="ios-buy" @click="openChat">
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import CommonTimer from '@/components/commonComponents/CommonTimer.vue';
import { judgmentPlatform } from '@/utils/tools';

export default {
  components: {
    CommonTimer,
  },
  props: {
    activeTab: {
      type: Number,
      default: 20,
    },
    priceInfo: {
      type: Object,
      default: () => ({
        price: '',
        originalPrice: '',
        endTime: '',
      }),
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    generateOrder: {
      type: Function,
      default: () => {},
    },
    openChat: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      time: '',
      isShowBuy: false,
      hidePrice: false,
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'priceInfo.endTime': {
      handler(value) {
        if (value) {
          this.time = moment(value).format('X');
        }
        this.isShowBuy = this.$root.miniprogram === false || this.$root.miniprogramBuyCourse;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    hideIosPrice() {
      this.hidePrice = this.$root.miniprogram && judgmentPlatform() === 'ios';
    },
  },
  mounted() {
    this.hideIosPrice();
  },
};
</script>

<style scoped lang="scss">
.buy {
  display: flex;
  align-items: center;
  width: 100%;
  height: 170px;
  margin-top: 10px;
  padding: 0 36px 62px;
  background: #fefffe;
  box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);
}
.buy.hidePrice {
  display: none;
}
.ios-buy {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 102;
  width: 100%;
  height: 123px;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member/ios-buy.png') no-repeat;
  background-size: 100%;
}
.desc {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
}

.text {
  height: 40px;
  color: #333;
  font-weight: 400;
  font-size: 25px;
  font-family: PingFangSC, PingFang SC, sans-serif;
  line-height: 40px;

  .num {
    color: #ff3938;
    font-weight: normal;
    font-size: 36px;
    font-family: Arial, sans-serif;
    line-height: 42px;
  }
}

.time {
  margin-top: 10px;
  color: #999;
  font-weight: 400;
  font-size: 22px;
  font-family: PingFangSC, PingFang SC, sans-serif;
  line-height: 31px;
}

::v-deep .common-timer {
  display: inline-block;

  .day::after {
    color: #999 !important;
    font-weight: 400;
    font-size: 22px !important;
    font-family: PingFangSC, PingFang SC, sans-serif;
  }

  b:nth-last-child(1),
  b:nth-last-child(2) {
    margin-left: 10px;

    &::after {
      right: -9px;
      color: rgba(255, 57, 56, 1);
    }
  }

  b:nth-last-child(3) {
    margin-left: 20px;

    &::after {
      right: -9px;
      color: rgba(255, 57, 56, 1);
    }
  }

  b:nth-last-child(4) {
    &::after {
      right: -18px !important;
    }
  }
}

.del {
  margin-right: 22px;
  color: #999;
  font-weight: 400;
  font-size: 22px;
  font-family: PingFangSC, PingFang SC, sans-serif;
  line-height: 31px;
  text-decoration: line-through;
}

.btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 199px;
  height: 71px;
  background: linear-gradient(270deg, #ff6c02 0%, #ff7f41 100%);
  border-radius: 35px;

  &-open {
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 40px;
  }

  &-chat {
    color: #fff;
    font-weight: 500;
    font-size: 25px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 36px;
  }

  &-desc {
    color: #fff;
    font-weight: 400;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 31px;
  }
}
</style>
